import geometryRouterPaths from './geometryRouterPaths';

export default geometryRouterPaths;
